import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface CloudyIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const CloudyIcon = observer('CloudyIcon', ({ className, onClick }: CloudyIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='currentcolor'
            height='32'
            onClick={onClick}
            viewBox='0 0 32 32'
            width='32'
            xmlns='http://www.w3.org/2000/svg'
            data-test='weather-icon'
        >
            <path
                fill='fill'
                fillRule='evenodd'
                d='M17.636 2v2.435h2V2h-2ZM30 12.364h-2.435v2H30v-2Zm-4.131-4.33 2.108-1.218 1 1.732-2.108 1.218-1-1.732Zm-2.417-5.012-1.218 2.11 1.733 1 1.217-2.11-1.732-1Zm-10.146 3.11-1.218-2.11 1.732-1 1.218 2.11-1.732 1ZM30 22.75c0-3.026-1.79-5.62-4.334-6.706a7.576 7.576 0 0 0-12.688-7.783 10.308 10.308 0 0 0-.478-.011C6.701 8.25 2 13.119 2 19.125S6.701 30 12.5 30c.066 0 .132 0 .197-.002V30H23.241v-.004C26.996 29.864 30 26.67 30 22.75Zm-5.846-9.386c0 .77-.157 1.505-.44 2.173a6.824 6.824 0 0 0-1.303-.012c-1.106-3.268-3.677-5.823-6.898-6.82a5.576 5.576 0 0 1 8.64 4.66ZM12.5 28h10.504C25.698 27.998 28 25.715 28 22.75c0-2.966-2.304-5.25-5-5.25-.73 0-1.432.168-2.066.47a9.037 9.037 0 0 0-.479-1.976l.003-.001c-1.221-3.383-4.36-5.743-7.958-5.743-4.629 0-8.5 3.907-8.5 8.875S7.871 28 12.5 28Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
